import useAccountingSetupConnectorId from './useAccountingSetupConnectorId';

import useQuilttSessionToken from 'services/quiltt/queries/useQuilttSessionToken';

interface ResolvabilityCheckSession {
    token: string | undefined;
    connectorId: string | undefined;
    /** Token and connector are both in hand, so the support checks can run. */
    canCheck: boolean;
    /**
     * When the support-check timeout may start: once the checks can run, or once it is certain they
     * never will. Waiting on the token first stops a slow token from timing out banks nobody has asked
     * Quiltt about yet; giving up on a failed one stops the caller hanging on its skeleton for good.
     */
    armTimeout: boolean;
}

/** The Quiltt session the Auto Statements support checks run in, and whether their timeout may start. */
export default function useResolvabilityCheckSession(): ResolvabilityCheckSession {
    const { data: sessionToken, isError, isSuccess } = useQuilttSessionToken();
    const connectorId = useAccountingSetupConnectorId();
    const token = sessionToken?.token;
    const canCheck = Boolean(token && connectorId);

    return {
        token,
        connectorId,
        canCheck,
        armTimeout: canCheck || isError || (isSuccess && (!token || !connectorId)),
    };
}
